// import { ChevronDown, ChevronUp } from "lucide-react";
// import { useState } from "react";

// const CollapsibleSection = ({ title, children, defaultOpen = true }) => {
//   const [isOpen, setIsOpen] = useState(defaultOpen);

//   return (
//     <div className="sidebar-section">
//       <div className="sidebar-header" onClick={() => setIsOpen(!isOpen)}>
//         <h4>{title}</h4>
//         {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
//       </div>
//       {isOpen && <div className="conversation-list">{children}</div>}
//     </div>
//   );
// };


// export default CollapsibleSection;
import { ChevronDown, ChevronUp, Users, MessageSquare, Network } from "lucide-react";
import { useState } from "react";

const CollapsibleSection = ({ title, children, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const getIcon = (sectionTitle) => {
    switch(sectionTitle.toLowerCase()) {
      case 'groups':
        return <Users size={16} className="text-[#0f6abf]" />;
      case 'inbox':
        return <MessageSquare size={16} className="text-[#0f6abf]" />;
      case 'connected users':
        return <Network size={16} className="text-[#0f6abf]" />;
      default:
        return null;
    }
  };

  return (
    <div className="sidebar-section">
      <div 
        className="flex items-center justify-between p-2 cursor-pointer hover:bg-gray-50 rounded-lg transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-[#e8f0f7] rounded-md flex items-center justify-center">
            {getIcon(title)}
          </div>
          <h4 className="font-semibold text-gray-700 text-sm">{title}</h4>
        </div>
        <div className="flex items-center">
          {isOpen ? (
            <ChevronUp size={16} className="text-gray-500" />
          ) : (
            <ChevronDown size={16} className="text-gray-500" />
          )}
        </div>
      </div>
      
      {isOpen && (
        <div className="mt-1">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;